/**
 * Wind Rider site chat bubble (v2).
 *
 * Same UX as the April v1 bubble, pointed at the wr-chat Cloudflare Worker.
 * Nothing in here is secret: the Worker holds the API key and does all the
 * checking. The widget only renders the conversation.
 *
 * NOT installed on the theme by this build. Shai pastes the snippet when he
 * says go live (chatbot/RULES.md §7).
 *
 * Override the endpoint before this script loads, e.g. for local testing:
 *   <script>window.WR_CHAT_API = 'http://127.0.0.1:8787/chat';</script>
 */
(function () {
  try {
    var WR_API_URL = window.WR_CHAT_API || 'https://wr-chat.windrider.workers.dev/chat';
    var WR_SUPPORT_EMAIL = 'service@windriderseatcovers.com';
    var WR_CONTACT_URL = 'https://windriderseatcovers.com/pages/contact-us';
    var WR_GREETING =
      "Hi! This is Wind Rider's automated assistant. Ask about the Wind Rider seat cover, whether it fits " +
      'your bike, installing, shipping, or returns.';
    var WR_MAX_CHARS = 1000;

    // ── Styles ──────────────────────────────────────────────────────────────
    var style = document.createElement('style');
    style.textContent = [
      '#wr-bubble {',
      '  position: fixed; bottom: 24px; right: 24px; width: 60px; height: 60px;',
      '  border-radius: 50%; background: #CC0102;',
      '  box-shadow: 0 8px 32px rgba(0,0,0,0.18);',
      '  cursor: pointer; display: flex; align-items: center; justify-content: center;',
      '  z-index: 9998; transition: transform 0.2s ease, box-shadow 0.2s ease; border: none;',
      '}',
      '#wr-bubble:hover { transform: scale(1.08); box-shadow: 0 12px 40px rgba(204,1,2,0.4); }',
      '#wr-bubble svg { width: 28px; height: 28px; fill: #fff; }',
      '#wr-bubble .wr-close-icon { display: none; }',
      '#wr-bubble.open .wr-chat-icon  { display: none; }',
      '#wr-bubble.open .wr-close-icon { display: block; }',
      '#wr-badge {',
      '  position: absolute; top: -2px; right: -2px; width: 18px; height: 18px;',
      '  border-radius: 50%; background: #fff; color: #CC0102;',
      '  font-size: 11px; font-weight: 700; display: none;',
      '  align-items: center; justify-content: center;',
      '}',
      '#wr-window {',
      '  position: fixed; bottom: 96px; right: 24px; width: 370px;',
      '  max-width: calc(100vw - 32px); height: 540px; max-height: calc(100vh - 120px);',
      '  background: #F5F0E8; border-radius: 14px;',
      '  box-shadow: 0 8px 32px rgba(0,0,0,0.18);',
      '  display: flex; flex-direction: column; overflow: hidden; z-index: 9997;',
      '  transform: scale(0.92) translateY(16px); opacity: 0; pointer-events: none;',
      '  transition: opacity 0.22s ease, transform 0.22s ease;',
      '  font-family: system-ui, sans-serif;',
      '}',
      '#wr-window.open { transform: scale(1) translateY(0); opacity: 1; pointer-events: all; }',
      '#wr-header {',
      '  background: #CC0102; padding: 14px 18px;',
      '  display: flex; align-items: center; gap: 12px; flex-shrink: 0;',
      '}',
      '#wr-header .wr-avatar {',
      '  width: 38px; height: 38px; border-radius: 50%;',
      '  background: rgba(255,255,255,0.25);',
      '  display: flex; align-items: center; justify-content: center; flex-shrink: 0;',
      '}',
      '#wr-header .wr-avatar svg { width: 20px; height: 20px; fill: #fff; }',
      '#wr-header .wr-info { flex: 1; overflow: hidden; }',
      '#wr-header .wr-name {',
      '  font-size: 14px; font-weight: 600; color: #fff;',
      '  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;',
      '}',
      '#wr-header .wr-status { font-size: 11px; color: rgba(255,255,255,0.85); margin-top: 2px; }',
      '#wr-messages {',
      '  flex: 1; overflow-y: auto; padding: 16px 14px;',
      '  display: flex; flex-direction: column; gap: 10px; scroll-behavior: smooth;',
      '}',
      '#wr-messages::-webkit-scrollbar { width: 4px; }',
      '#wr-messages::-webkit-scrollbar-track { background: transparent; }',
      '#wr-messages::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }',
      '.wr-msg {',
      '  display: flex; flex-direction: column; max-width: 82%;',
      '  animation: wr-fadein 0.2s ease forwards;',
      '}',
      '@keyframes wr-fadein {',
      '  from { opacity: 0; transform: translateY(6px); }',
      '  to   { opacity: 1; transform: translateY(0); }',
      '}',
      '.wr-msg.bot  { align-self: flex-start; }',
      '.wr-msg.user { align-self: flex-end; }',
      '.wr-msg .wr-bubble-text {',
      '  padding: 10px 14px; border-radius: 14px;',
      '  font-size: 13.5px; line-height: 1.5; word-break: break-word; white-space: pre-wrap;',
      '}',
      '.wr-msg.bot  .wr-bubble-text {',
      '  background: #fff; color: #4D4D4D;',
      '  border: 1px solid #e0e0e0; border-bottom-left-radius: 4px;',
      '}',
      '.wr-msg.user .wr-bubble-text {',
      '  background: #CC0102; color: #fff; border-bottom-right-radius: 4px;',
      '}',
      '.wr-msg .wr-time { font-size: 10px; color: #888; margin-top: 4px; padding: 0 4px; }',
      '.wr-msg.bot  .wr-time { align-self: flex-start; }',
      '.wr-msg.user .wr-time { align-self: flex-end; }',
      '.wr-msg.bot .wr-bubble-text a {',
      '  color: #CC0102; text-decoration: underline; word-break: break-all;',
      '}',
      '#wr-typing {',
      '  display: none; align-self: flex-start; align-items: center; gap: 5px;',
      '  padding: 10px 14px; background: #fff; border-radius: 14px;',
      '  border-bottom-left-radius: 4px; border: 1px solid #e0e0e0;',
      '}',
      '#wr-typing.visible { display: flex; }',
      '#wr-typing span {',
      '  width: 7px; height: 7px; border-radius: 50%; background: #aaa;',
      '  animation: wr-bounce 1.2s infinite;',
      '}',
      '#wr-typing span:nth-child(2) { animation-delay: 0.2s; }',
      '#wr-typing span:nth-child(3) { animation-delay: 0.4s; }',
      '@keyframes wr-bounce {',
      '  0%, 60%, 100% { transform: translateY(0); }',
      '  30%           { transform: translateY(-6px); }',
      '}',
      '#wr-footer {',
      '  padding: 12px 14px; background: #fff;',
      '  display: flex; gap: 8px; align-items: flex-end;',
      '  flex-shrink: 0; border-top: 1px solid #e8e8e8;',
      '}',
      '#wr-input {',
      '  flex: 1; background: #fff; border: 1px solid #ddd; border-radius: 22px;',
      '  color: #4D4D4D; font-size: 13.5px; font-family: system-ui, sans-serif;',
      '  padding: 9px 16px; resize: none; max-height: 120px; overflow-y: auto;',
      '  outline: none; transition: border-color 0.15s; line-height: 1.45;',
      '}',
      '#wr-input::placeholder { color: #aaa; }',
      '#wr-input:focus { border-color: #CC0102; }',
      '#wr-send {',
      '  width: 40px; height: 40px; border-radius: 50%; background: #CC0102;',
      '  border: none; cursor: pointer; display: flex; align-items: center;',
      '  justify-content: center; flex-shrink: 0;',
      '  transition: background 0.15s, transform 0.15s;',
      '}',
      '#wr-send:hover { background: #a80001; transform: scale(1.05); }',
      '#wr-send:disabled { background: #ccc; cursor: default; transform: none; }',
      '#wr-send svg { width: 18px; height: 18px; fill: #fff; }',
      '#wr-handoff {',
      '  text-align: center; font-size: 11px; color: #777;',
      '  padding: 6px 10px 9px; background: #fff; flex-shrink: 0; line-height: 1.5;',
      '}',
      '#wr-handoff a { color: #CC0102; text-decoration: none; }',
      '#wr-handoff a:hover { text-decoration: underline; }',
      '@media (max-width: 420px) {',
      '  #wr-window {',
      '    bottom: 0; right: 0; left: 0; width: 100%; max-width: 100%;',
      '    height: 100dvh; max-height: 100dvh; border-radius: 0;',
      '  }',
      '  #wr-bubble { bottom: 20px; right: 20px; }',
      '  #wr-bubble.open { display: none; }',
      '}',
    ].join('\n');
    document.head.appendChild(style);

    // ── HTML ────────────────────────────────────────────────────────────────
    document.body.insertAdjacentHTML('beforeend', [
      '<button id="wr-bubble" aria-label="Open the Wind Rider assistant">',
      '  <div id="wr-badge"></div>',
      '  <svg class="wr-chat-icon" viewBox="0 0 24 24"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z"/></svg>',
      '  <svg class="wr-close-icon" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>',
      '</button>',
      '<div id="wr-window" role="dialog" aria-label="Wind Rider automated assistant">',
      '  <div id="wr-header">',
      '    <div class="wr-avatar">',
      '      <svg viewBox="0 0 24 24"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z"/></svg>',
      '    </div>',
      '    <div class="wr-info">',
      '      <div class="wr-name">Wind Rider Assistant</div>',
      '      <div class="wr-status">Automated assistant</div>',
      '    </div>',
      '  </div>',
      '  <div id="wr-messages" aria-live="polite">',
      '    <div id="wr-typing"><span></span><span></span><span></span></div>',
      '  </div>',
      '  <div id="wr-footer">',
      '    <textarea id="wr-input" rows="1" maxlength="' + WR_MAX_CHARS + '"',
      '      placeholder="Ask about your bike or our covers..."',
      '      aria-label="Type your message"></textarea>',
      '    <button id="wr-send" aria-label="Send message">',
      '      <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>',
      '    </button>',
      '  </div>',
      '  <div id="wr-handoff">',
      '    Prefer a human? <a href="mailto:' + WR_SUPPORT_EMAIL + '">Email us instead</a>',
      '    or use the <a href="' + WR_CONTACT_URL + '" target="_blank" rel="noopener">contact form</a>.',
      '  </div>',
      '</div>',
    ].join('\n'));

    // ── State ───────────────────────────────────────────────────────────────
    var wrIsOpen = false;
    var wrBusy = false;
    // The conversation history lives on the Worker, keyed by session_id. The
    // widget only ever sends the new message: browser supplied assistant turns
    // are not trusted as the bot's own words.

    function wrSessionId() {
      var bytes = new Uint8Array(16);
      (window.crypto || window.msCrypto).getRandomValues(bytes);
      var hex = '';
      for (var i = 0; i < bytes.length; i++) hex += ('0' + bytes[i].toString(16)).slice(-2);
      return 'wr-' + hex;
    }
    var wrSession = wrSessionId();

    var $ = function (id) { return document.getElementById(id); };

    function wrToggle() {
      wrIsOpen = !wrIsOpen;
      $('wr-window').classList.toggle('open', wrIsOpen);
      $('wr-bubble').classList.toggle('open', wrIsOpen);
      $('wr-badge').style.display = 'none';
      if (wrIsOpen) {
        if (!$('wr-messages').querySelectorAll('.wr-msg').length) wrAddMessage('bot', WR_GREETING);
        if (window.innerWidth > 420) $('wr-input').focus();
      }
    }

    async function wrSend() {
      if (wrBusy) return;
      var input = $('wr-input');
      var text = (input.value || '').trim();
      if (!text) return;
      if (text.length > WR_MAX_CHARS) text = text.slice(0, WR_MAX_CHARS);
      input.value = '';
      wrAutoResize(input);
      wrAddMessage('user', text);
      wrSetBusy(true);

      var payload = { session_id: wrSession, messages: [{ role: 'user', content: text }] };
      try {
        var res = await fetch(WR_API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        var data = await res.json().catch(function () { return {}; });
        if (data && data.reply) {
          wrAddMessage('bot', data.reply);
        } else {
          wrAddMessage('bot', wrFallbackText());
        }
      } catch (e) {
        wrAddMessage('bot', wrFallbackText());
      } finally {
        wrSetBusy(false);
      }
    }

    function wrFallbackText() {
      return 'Sorry, we are having trouble connecting right now. Please email our customer service team at ' +
        WR_SUPPORT_EMAIL + ' and they will take care of you.';
    }

    function wrAddMessage(role, text) {
      var msgs = $('wr-messages');
      var typer = $('wr-typing');
      var wrap = document.createElement('div');
      wrap.className = 'wr-msg ' + role;
      var bubble = document.createElement('div');
      bubble.className = 'wr-bubble-text';
      if (role === 'bot') bubble.innerHTML = wrLinkify(text);
      else bubble.textContent = text;
      var time = document.createElement('div');
      time.className = 'wr-time';
      time.textContent = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      wrap.appendChild(bubble);
      wrap.appendChild(time);
      msgs.insertBefore(wrap, typer);
      msgs.scrollTop = msgs.scrollHeight;
      if (!wrIsOpen) $('wr-badge').style.display = 'flex';
    }

    function wrSetBusy(busy) {
      wrBusy = busy;
      $('wr-typing').classList.toggle('visible', busy);
      $('wr-send').disabled = busy;
      $('wr-input').disabled = busy;
      if (busy) $('wr-messages').scrollTop = $('wr-messages').scrollHeight;
      if (!busy && wrIsOpen && window.innerWidth > 420) $('wr-input').focus();
    }

    // Escape first, then linkify: bot text is rendered as HTML.
    function wrLinkify(text) {
      var esc = String(text)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
      esc = esc.replace(/(https?:\/\/[^\s<>"]+[^\s<>".,;:!?)])/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
      return esc.replace(/([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g, '<a href="mailto:$1">$1</a>');
    }

    function wrAutoResize(el) {
      el.style.height = 'auto';
      el.style.height = Math.min(el.scrollHeight, 120) + 'px';
    }

    $('wr-bubble').addEventListener('click', wrToggle);
    $('wr-send').addEventListener('click', wrSend);
    $('wr-input').addEventListener('input', function () { wrAutoResize(this); });
    $('wr-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); wrSend(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wrIsOpen) wrToggle(); });
  } catch (e) {
    // A broken widget must never break the storefront, and it reports nothing
    // anywhere: v1's error beacon was an open public endpoint.
    if (window.console && console.error) console.error('Wind Rider widget failed to initialize:', e);
  }
})();
